<template>
  <MasterLayout>
    <section>
      <Navbar />
      <section :class="`${widthStyle} `">
        <Loader v-if="showLoader || !depotDetails" />
        <section v-else>
          <!-- <section class="flex justify-between my-2">
            <img
              @click="$router.go(-1)"
              class="inline pt-1 pb-2 mr-3 cursor-pointer"
              aria-hidden="true"
              title="go back"
              src="@/assets/svg/Caretleft.svg"
            />
          </section> -->
          <DetailsSection
            v-if="depotDetails"
            :loader="deleteLoader"
            :showDrawer="showDrawer"
            :details="depotDetails"
            :products="depotProducts"
            :getDepotDetails="getDepotDetails"
            :handleOpenDrawers="openDrawerHandler"
            :handleCloseDrawers="closeDrawer"
            :editDrawerHandler="handleEditDrawer"
            :mapProductHandler="handleMapProductDrawer"
            ref="sectionComponent"
          />

          <ProductCarousel
            v-if="depotProducts"
            class="mt-2"
            :products="depotProducts"
            :openMapProductDrawer="openMapDrawer"
            :callEndPoints="callEndpoints"
          />
          <section class="my-10">
            <DepotTables :details="depotDetails" :depotId="depotId" />
          </section>

          <section>
            <EditDepotDrawer
              :depotDetails="depotDetails"
              :open="openEditDrawer"
              :close="handleEditDrawer"
              :handleReset="callEndpoints"
            />
            <InventoryDrawer
              :open="inventoryDrawerActive"
              :close="closeDrawer"
              :products="inventoryProduct"
              :getDepotDetails="callEndpoints"
            />
            <PriceDrawer
              :open="changPriceDrawerActive"
              :closeDrawer="closeDrawer"
              :products="inventoryProduct"
              :getDepotDetails="callEndpoints"
            />
            <MapProductDepotDrawer
              :open="openMapProductDrawer"
              :close="handleMapProductDrawer"
              :products="inventoryProduct"
              :getDepotDetails="callEndpoints"
            />
          </section>
        </section>
      </section>
    </section>
  </MasterLayout>
</template>
<script>
//assets

//libraries
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";

//services
import depotService from "@/services/depot-service";

//utils
import { formatDate, formatNumber } from "@/utils/formatter";
import { widthStyle } from "@/utils/generalWidthStyle";

//components
import Loader from "@/components/UI/Loader";
import Navbar from "@/components/UI/Navbar.vue";
import MasterLayout from "@/views/MasterLayout.vue";
import DepotTables from "@/components/Tables/Depot/DepotTables.vue";
import EditDepotDrawer from "@/components/pages/Depot/EditDepotDrawer.vue";
import DetailsSection from "@/components/pages/Depot/Details/DetailsSection.vue";
import PriceDrawer from "@/components/pages/Depot/Drawers/ChangePriceDrawer.vue";
import ProductCarousel from "@/components/pages/Depot/Details/ProductCarousel.vue";
import InventoryDrawer from "@/components/pages/Depot/Drawers/InventoryUpdateDrawer.vue";
import MapProductDepotDrawer from "@/components/pages/Depot/Drawers/MapProductDepotDrawer.vue";

export default {
  name: "Depot Details",
  components: {
    Navbar,
    Loader,
    PriceDrawer,
    DepotTables,
    MasterLayout,
    DetailsSection,
    ProductCarousel,
    EditDepotDrawer,
    InventoryDrawer,
    VueCtkDateTimePicker,
    MapProductDepotDrawer,
  },
  data() {
    return {
      priceLog: [],
      depotId: this.$route.query.id,
      depotDetails: null,
      depotProducts: null,
      openDrawer: false,
      widthStyle: widthStyle,
      inventoryDrawerActive: false,
      openEditDrawer: false,
      changPriceDrawerActive: false,
      showLoader: true,
      deleteLoader: false,
      status: "",
      inventoryProduct: [],
      openMapProductDrawer: false,
    };
  },
  watch: {
    depotId: function (newId) {
      if (newId) {
        this.getDepotDetails();
      }
    },
  },
  created() {},
  mounted() {
    this.callEndpoints();
  },

  methods: {
    //Requests
    callEndpoints() {
      this.getDepotDetails();
      this.getDepotProducts();
    },

    async getDepotProducts() {
      this.showLoader = true;

      try {
        const result = await depotService.getDepotProducts(this.depotId);
        this.inventoryProduct = result.data;

        if (result) {
          result.data.forEach((el) => {
            el.maxCapacity = el.maxCapacity;
            el.price = el.price;
            el.currentQuantity = el.currentQuantity;
          });

          this.depotProducts = result.data;
        }
        this.showLoader = false;
      } catch (err) {
        this.showLoader = false;
      }
    },

    async getDepotDetails() {
      this.showLoader = true;

      try {
        const result = await depotService.getDepotDetails(this.depotId);

        if (result) {
          this.depotDetails = result.data;
        }
        this.showLoader = false;
      } catch (err) {
        this.showLoader = false;
      }
    },

    //utilities

    openMapDrawer() {
      console.log("kjs");
      this.$refs.sectionComponent.mapProductHandler("open");
    },

    handleEditDrawer(args) {
      if (args === "open") {
        this.openEditDrawer = true;
        return;
      }
      this.openEditDrawer = false;
    },
    handleMapProductDrawer(drawerType) {
      if (drawerType == "open") {
        this.openMapProductDrawer = true;
        return;
      }
      this.openMapProductDrawer = false;
    },
    closeDrawer(drawerType) {
      if (drawerType == "inventory") {
        this.inventoryDrawerActive = false;
        return;
      }
      this.changPriceDrawerActive = false;
    },
    openDrawerHandler(drawerType) {
      if (drawerType == "inventory") {
        this.inventoryDrawerActive = true;
        return;
      }
      this.changPriceDrawerActive = true;
    },
    showDrawer() {
      this.openDrawer = true;
    },
  },
};
</script>

<style></style>
